import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/road-trip-cost-calculator',
  component: () => import('../../routes/RoadTripCost.svelte'),
  card: {
    id: 'road-trip-cost-calculator',
    title: 'Road Trip Cost Calculator',
    description: 'Estimate the total cost of a road trip including fuel, accommodation, food, activities, tolls, and parking.',
    icon: 'directions_car',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/road-trip-cost-calculator',
    category: 'Travel & Distance',
  },
  seo: {
    title: 'Road Trip Cost Calculator – Estimate Total Trip Expenses',
    description: 'Free road trip cost calculator. Estimate fuel, accommodation, food, activities, tolls, and parking costs for your next road trip. Calculate total and per-person costs.',
  },
};

export default meta;
